import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["defaultItem", "trackId", "lessonId", "allowList", "filterType", "onSelect", "bypassSearchParamUpdate"];
import I18n from 'I18n';
// @ts-expect-error Untyped
import { useSearchParam } from '../../hooks/searchParamHooks';
import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Untyped
import useLanguageRequested from '../../hooks/useLanguageRequests';
import UsageTracker from '../../utils/UsageTracker';
import { FilterItems } from './FilterItems';
import { useCanFilterContentTypeByPlaylist } from '../../features/filters/filtersHooks';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const MobileFilterSingleSelect = _ref => {
  let {
      defaultItem,
      trackId,
      lessonId,
      allowList,
      filterType,
      onSelect,
      bypassSearchParamUpdate
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const canFilterContentTypeByPlaylist = useCanFilterContentTypeByPlaylist();
  let options = FilterItems[filterType];
  const [__, changeHandler] = useSearchParam(filterType);
  const allowListLL = allowList && allowList.map(a => a.toLowerCase());
  if (!canFilterContentTypeByPlaylist) {
    options = options.filter(item => item !== 'LEARNING_PATH');
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: options.map(option => {
      const disabled = allowListLL && !allowListLL.includes(option.toLowerCase());

      // eslint-disable-next-line react-hooks/rules-of-hooks
      const [languageRequested, setLanguageRequested] = useLanguageRequested({
        trackId,
        lessonId,
        language: option
      });
      return /*#__PURE__*/_jsxs(TFlex, {
        onClick: () => {
          if (!disabled) {
            if (onSelect) onSelect(option);
            if (!bypassSearchParamUpdate) changeHandler(option);
            UsageTracker.track('filterInteraction', {
              action: 'filter-selected',
              value: option,
              key: 'language-switcher',
              defaultValue: defaultItem
            });
          }
        },
        children: [/*#__PURE__*/_jsx(Button, Object.assign({
          disabled: disabled,
          use: "unstyled"
        }, props, {
          children: /*#__PURE__*/_jsx(View, {
            color: disabled ? 'text-core-disabled' : 'text-core-default',
            inlineSize: "100%",
            textAlign: "start",
            children: filterType === 'language' ? LanguageNames[option.toLowerCase()] : I18n.text(`learningCenter.topFilters.${filterType}.${option}`)
          })
        })), disabled && (trackId || lessonId) && /*#__PURE__*/_jsx(Button, Object.assign({
          "data-no-full-width": "true",
          disabled: languageRequested,
          onClick: setLanguageRequested,
          padding: "100",
          responsive: false,
          use: "transparent"
        }, props, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `learningCenter.requestLanguage.${languageRequested ? 'requested' : 'request'}.button`
          })
        }))]
      }, option);
    })
  });
};
export default MobileFilterSingleSelect;